import { LazyWhiteboardCanvas } from '../../components/whiteboard/LazyWhiteboardCanvas';
import { UserType } from '../../types';
import { useVisitorId } from '../useVisitorId';

export function VisitorWhiteboard() {
  const visitorId = useVisitorId();
  return (
    <LazyWhiteboardCanvas
      senderIdentity={{
        entityType: UserType.CLIENT,
        entityId: visitorId,
      }}
    />
  );
}
